<template>
  <v-container class="py-10 py-md-13 py-lg-16">
    <div class="d-flex flex-column align-center">
      <v-icon :size="xs ? 100 : 140" color="success">
        far fa-check-circle
      </v-icon>

      <TitleWidget class="mt-4 mt-md-6">
        {{ intro }}
      </TitleWidget>

      <div
        v-if="text"
        class="
          primary--text
          text--lighten-1 text-body-1 text-sm-h6 text-center
          font-weight-medium
          mt-3
        "
      >
        {{ text }}
      </div>

      <ButtonWidget @click="back" class="mt-8">
        <v-icon size="16" left> fas fa-arrow-left </v-icon>
        Voltar
      </ButtonWidget>
    </div>
  </v-container>
</template>

<script>
import ButtonWidget from "../components/widgets/ButtonWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";

export default {
  data: () => ({
    intro: "Sua mensagem foi enviada com sucesso.",
    text: "Muito obrigado! Entraremos em contato em breve.",
  }),
  components: {
    ButtonWidget,
    TitleWidget,
  },
};
</script>
